import dynamic from 'next/dynamic';

import { ListingNotFoundContentsViewModel } from '@api/v3';

const NotFoundTourListing = dynamic(() => import('./TourListingNotFound'));
const NotFoundCruiseListing = dynamic(() => import('./CruiseListingNotFound'));

type Props = {
  tourListCount: number;
  type?: 'hotel' | 'tour' | 'ship';
  popularSearchData?: ListingNotFoundContentsViewModel;
};

const NotFoundListing = ({ tourListCount, type, popularSearchData }: Props) => {
  return type === 'tour' ? (
    <NotFoundTourListing
      tourListCount={tourListCount}
      popularSearchData={popularSearchData}
    />
  ) : (
    <NotFoundCruiseListing
      tourListCount={tourListCount}
      popularSearchData={popularSearchData}
    />
  );
};

export default NotFoundListing;
